import React from "react";
import QuoteContext, { IQuoteData } from "components/Quotes/QuoteContext";

export function useQuoteData(): IQuoteData {
    const quoteData = React.useContext(QuoteContext);
    return quoteData;
};

export default useQuoteData;
